import { gql } from '@apollo/client';

export const INSTITUTION = gql`
  fragment institution on Institution {
    id
    # Scalars
    addressee
    ageRange0To18Months
    ageRange18MonthsTo3Years
    ageRange3To4Years
    ageRange4To5Years
    ageRange5To6Years
    allocation
    assessedForMaintenanceGrant
    certificateNumber
    circuit {
      id
      name
    }
    componentNumber
    districtMunicipality {
      id
      name
    }
    duplicateAction
    duplicateReference
    ecdServiceType
    educatorNumber
    emisNumber
    schoolEmmisNumber
    exDept
    examCentre
    examNumber
    expiryDate
    facsimile
    fundedThroughConditionalGrant
    fundedThroughEquitableShare
    gisAltitude
    gisLatitude
    gisLongitude
    gisSource
    gradeROffered
    isArchived
    issueDate
    learnerNumber
    locality
    localMunicipality {
      id
      localMunicipality
      localMunicipalityShorthand
    }
    monthlyFeeRangeHighest
    monthlyFeeRangeLowest
    name
    nas
    nearestPointOfInterest
    newEmisNumber
    newOrRenewal
    noFeeSchool
    npoNumber
    numberOfChildrenEnrolled
    numberOfChildrenFunded
    numberOfStaff
    officeContactNumber
    officeEmailAddress
    openBoardingSchool
    ownerBuild
    ownerLand
    ownership
    paypointNumber
    physicalAddress
    pointOfInterest
    postalAddress
    postalCode
    privateOrNpo
    provinceCD
    quintile
    reasonForDuplicateAction
    receivedMaintenanceGrant
    region {
      id
    }
    registrationDate
    registrationOffice {
      id
      isInstitution
      isServiceProvider
      institution {
        id
        name
      }
      serviceProvider {
        id
        name
      }
    }
    registrationStatus {
      id
      name
    }
    registrationType {
      id
      name
    }
    section21
    section21Function
    specialization
    status
    streetAddress
    streetNo
    suburb
    townCity
    townshipVillage
    streetBuilding
    area
    wardID
    wardLabel
    year
    yearOfReceipt
    languageOfLearning
    closingTime
    openingTime
    afterCareForSchoolGoing
    primarySchoolName
    primarySchoolEmis
    isEcdServicePrimarySchoolBased
    hasHolidays
    numberOfDaysServiceOperate
    yearEcdStartedOperating
    legalEntity
    registeredAsNpo
    district {
      id
      name
    }
    type {
      id
      name
    }
  }
`;
